import React from 'react';
import classNames from 'classnames';
import CheckIcon from '@reverbdotcom/cadence/icons/core/check.svg?component';
import { RCCheckableLabel } from './RCCheckableLabel';
import { CommonInputProps } from '../../types';
import { RCSwitch } from './RCSwitch';
import { RCIcon } from '../../';

export interface IRCCheckbox extends CommonInputProps {
  /** Passed through to the input tag. */
  checked: boolean;

  /** The 'Switch' variant renders a sliding switch; some props **aren't supported yet**: `required`, `errorText`, and `helpText`. */
  variant?: 'checkbox' | 'switch';

  /** Additional line of text below main label; sentence-case without ending punctuation. Not rendered if `variant` is set to `switch`. */
  sublabel?: string;
}

/**
 * A styled checkbox element. Never use a default `<input type="checkbox">`, always use this. Available as a stylized Switch as well with its `variant` prop.
 */
export function RCCheckbox({ variant = 'checkbox', ...props }: IRCCheckbox) {
  if (variant === 'switch') {
    return <RCSwitch {...props} />;
  }

  return (
    <span className={classNames(
      'rc-checkbox',
      { 'rc-checkbox--disabled': props.disabled },
    )}>
      <input
        className="rc-checkbox__input"
        type="checkbox"
        name={props.name}
        id={props.id}
        checked={props.checked}
        onChange={props.onChange}
        disabled={props.disabled}
        required={props.required}
      />
      <span className="rc-checkbox__box">
        <RCIcon svgComponent={CheckIcon} />
      </span>
      <RCCheckableLabel
        for={props.id}
        sublabel={props.sublabel}
        label={props.label}
        errorText={props.errorText}
      />
    </span>
  );
}
